import type { AgentNodeData } from '@saaga/shared/interfaces/agency-node.interface'
import { Handle, Position } from '@xyflow/react'
import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { AgentNodeIcon } from './agent-node-icon.atom'

interface AgentNodePreviewProps {
  data: AgentNodeData
}

export const AgentNodePreview = memo(
  ({ data }: AgentNodePreviewProps): ReactNode => (
    <div
      className={cn(
        'agent-node-preview relative rounded-lg border-2 bg-background shadow-md',
        'min-w-[200px] max-w-[220px]',
        'border-border',
        data.isEntryPoint && 'border-amber-500'
      )}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!size-0 !border-0 !bg-transparent"
        isConnectable={false}
      />
      <div className="agent-node-preview-content flex flex-col gap-1 p-3">
        <div className="agent-node-preview-header flex items-center gap-2">
          <AgentNodeIcon isEntryPoint={data.isEntryPoint} />
          <div className="agent-node-preview-info min-w-0 flex-1">
            <p className="agent-node-preview-label truncate text-sm font-medium">{data.label}</p>
            {data.isEntryPoint && (
              <p className="agent-node-preview-role text-xs text-amber-600">Entry Point</p>
            )}
          </div>
        </div>
        <div className="agent-node-preview-meta mt-1 flex items-center gap-2 text-xs text-muted-foreground">
          <span className="agent-node-preview-model truncate">{data.model.split('/')[1]}</span>
          <span className="agent-node-preview-temp">T: {data.temperature}</span>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="!size-0 !border-0 !bg-transparent"
        isConnectable={false}
      />
    </div>
  )
)

AgentNodePreview.displayName = 'AgentNodePreview'
